import axios from 'axios';

import { HSCAN_BACKEND_API_URL } from '../../env';

export interface MaskedPhoneNumberResponse {
  phoneNumberMasked: string;
}
export const requestMaskedPhone = () => {
  return axios.get<MaskedPhoneNumberResponse>(
    `${HSCAN_BACKEND_API_URL}/two-factor-login/phone`,
  );
};

export const requestTwoFactorLogin = () => {
  return axios.post<void>(`${HSCAN_BACKEND_API_URL}/two-factor-login/request`);
};

export interface AuthenticationCodeAuthorize {
  code: string;
  remember30days: boolean;
}
export const authorizeTwoFactorLogin = (
  request: AuthenticationCodeAuthorize,
) => {
  return axios.post<void>(
    `${HSCAN_BACKEND_API_URL}/two-factor-login/authorize`,
    request,
  );
};
